<div class="cowing-input-container">
  <div class="cowing-input-container">
    <div *ngIf="label.length > 0" class="label">
      {{ label | translate }}
    </div>
    <input
      #input
      *ngIf="!isForm"
      [ngClass]="'input-' + inputStyle"
      [type]="'time'"
      [placeholder]="placeholder"
      [(ngModel)]="value"
      (input)="onInputChange($event)"
      [disabled]="disabled"
    />
    <input
      #input
      *ngIf="isForm"
      [ngClass]="[
        control.invalid && control.touched ? 'input-invalid' : '',
        'input-' + inputStyle
      ]"
      [type]="'time'"
      [placeholder]="placeholder"
      [formControl]="control"
    />
  </div>
</div>
